@if (menuItem) {
  <a
    *appPermission="menuItem.permission; and: menuItem.condition"
    mat-button
    class="nav-link text-md-bold"
    color="primary"
    routerLinkActive="active"
    [routerLink]="menuItem.link"
    [matBadge]="menuItem.hasBadge ? '0' : ''"
    [matBadgeHidden]="!menuItem.hasBadge"
    [appTooltip]="menuItem.tooltipText"
    [tooltipTitle]="menuItem.tooltipTitle"
    [tooltipPinned]="true"
    [tooltipDisabled]="!menuItem.tooltipEnabled"
    (closeTooltip)="onCloseTooltip()"
  >
    {{ menuItem.name }}
  </a>
}
